export default "__VITE_ASSET__cd794fab__"